import { render, staticRenderFns } from "./MyLessonsDesktop.vue?vue&type=template&id=9aa9ab8c&scoped=true"
import script from "./MyLessonsDesktop.vue?vue&type=script&lang=js"
export * from "./MyLessonsDesktop.vue?vue&type=script&lang=js"
import style0 from "./MyLessonsDesktop.vue?vue&type=style&index=0&id=9aa9ab8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aa9ab8c",
  null
  
)

export default component.exports